exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Serif+Text:ital@0;1&display=swap);", ""]);

// module
exports.push([module.id, ".CodeVerificationSuccessModal-verificationContent-2bypb {\n    text-align: center;\n}\n.CodeVerificationSuccessModal-titleText-3Qbiy {\n    font-size: 24px;\n    font-weight: 400;\n    margin : 28px 0 24px 0;\n    color: #0C3C64;\n    font-family: 'DM Serif Text', serif;\n}\n.CodeVerificationSuccessModal-verificationImage-styy3{\n    width: 90px;\n}", ""]);

// exports
exports.locals = {
	"verificationContent": "CodeVerificationSuccessModal-verificationContent-2bypb",
	"titleText": "CodeVerificationSuccessModal-titleText-3Qbiy",
	"verificationImage": "CodeVerificationSuccessModal-verificationImage-styy3"
};